var d2 = "/static/e22bd7057a2fcf1f.png";

export { d2 as default };
//# sourceMappingURL=d_2.png.js.map
